export default __webpack_public_path__ + "static/media/ipad_konfety.ae02206a.png";